import { catalogCenterJa } from "./catalog-center";
import { centersCenterJa } from "./centers-center";
import { loginCenterJa } from "./login-center";
import { platformAdminApplications } from "./platform-admin-applications";
import { platformAdminAssets } from "./platform-admin-assets";
import { platformAdminCommon } from "./platform-admin-common";
import { platformAdminDashboard } from "./platform-admin-dashboard";
import { platformAdminExecution } from "./platform-admin-execution";
import { platformAdminIdentity } from "./platform-admin-identity";
import { platformAdminNavigation } from "./platform-admin-navigation";
import { platformAdminPortalManagement } from "./platform-admin-portal-management";
import { platformAdminValues } from "./platform-admin-values";

export const platformAdmin = {
  title: "プラットフォーム管理",
  shellSubtitle: "プラットフォーム制御面",
  links: platformAdminNavigation.links,
  menu: platformAdminNavigation.menu,
  common: platformAdminCommon,
  values: platformAdminValues,
  dashboard: platformAdminDashboard,
  portalManagement: platformAdminPortalManagement,
  applications: platformAdminApplications,
  assets: platformAdminAssets,
  execution: platformAdminExecution,
  identity: platformAdminIdentity,
  centers: centersCenterJa,
  catalog: catalogCenterJa,
  login: loginCenterJa,
} as const;
